import { useRestaurant } from 'restaurantAdmin/context/useRestaurant';
import { useMessagingDrawer } from 'restaurantAdmin/messaging/hooks';
import { Button, ButtonVariants } from '@components/button/Button';
import cx from 'classnames';
import typography from '~styles/typography.scss';
import styles from './MultiSelectDetails.scss';

type Props = {
  selectedGuestIds: string[];
};

export const MultiSelectDetails = ({ selectedGuestIds }: Props) => {
  const { openMessagingDrawer } = useMessagingDrawer();
  const restaurant = useRestaurant();
  const lacksSMSNumber = !restaurant.smsPhoneNumber;

  return (
    <div data-testid="multi-select-count" className={cx(styles.container)}>
      <div className={cx(styles.countFrame, typography.h3)}>
        {selectedGuestIds.length}
      </div>
      <p
        className={typography.h4}
        style={{ fontVariantNumeric: 'tabular-nums' }}
      >
        {selectedGuestIds.length} guest(s) selected
      </p>
      <Button
        label="Text Message Guests"
        onClick={() => openMessagingDrawer(selectedGuestIds)}
        variant={ButtonVariants.Primary}
        isDisabled={lacksSMSNumber || selectedGuestIds.length === 0}
      />
      {lacksSMSNumber &&
        "The restaurant hasn't been given a dedicated SMS number. Please contact your account manager."}
    </div>
  );
};
